import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/risk-assessment')({
  component: RiskAssessmentWizard,
});

function RiskAssessmentWizard() {
  return <Outlet />;
}
